import { render, staticRenderFns } from "./product.vue?vue&type=template&id=6a7fae12&scoped=true"
import script from "./product.js?vue&type=script&lang=js&external"
export * from "./product.js?vue&type=script&lang=js&external"
import style0 from "./product.vue?vue&type=style&index=0&id=6a7fae12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7fae12",
  null
  
)

export default component.exports